import { useMemo } from 'preact/hooks';
import { useConfigStore, useFormProps } from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';
import Track from '../utils/Track';
import useFormCompletionPercentage from './useFormCompletionPercentage';
import useFeedback from './useFeedback';

export default function useIntegrations() {
	const { properties, pageMap } = useConfigStore();
	const { activePage, formType } = useFormStore();
	const { disablePost, formKey, triggerMethod, domain, metricsDomain } = useFormProps();
	const formCompletionPercentage = useFormCompletionPercentage();
	const feedback = useFeedback({
		addExtraData: true,
		noOpenOrPIIFeedback: true,
		excludeScreenShotDom: true
	});
	const integrations = useMemo(
		() =>
			new Track({
				advanced: properties?.advanced ?? {},
				disablePost,
				formKey,
				formName: properties.name,
				metricsDomain
			}),
		[properties?.advanced, disablePost, formKey, properties.name, metricsDomain]
	);

	integrations
		.setEventProps({
			trigger_method: triggerMethod,
			form_completion_percentage: formCompletionPercentage,
			active_page: activePage,
			page_count: Object.keys(pageMap).pop(),
			form_type: formType,
			subdomain: domain,
			organisation_id: properties.organisation_id,
			project_id: properties.project_id
		})
		.setFeedback(feedback);

	return {
		sendEvent: integrations.send,
		sendFeedback: integrations.sendFeedback
	};
}
